import Conexion_api from "@/api/Conexion_api.js";

const decrypt_pushDT = function(pushDT, base = null){
  return new Promise((resuelve,rechaza) => {
    Conexion_api({
        body: {
            base: base,
            pushDT: pushDT
        },
        evento: "notificaciones_push/decrypt_pushDT"
    }).then(respuesta => {        
        if(respuesta.data.error){
          this.$root.$emit("snackbar", {
            color: "error",
            texto: respuesta.data.error,
          });
          resuelve(false);                 
      }         
      resuelve(respuesta.data.datos)        
    
    }).catch(err => {
        err = String(err);
        this.$root.$emit("snackbar", { color: "error", texto: err });    
        console.error(err);
        rechaza(false); 
    })
  })
}
export default decrypt_pushDT